import React from "react";
import "../styles/PrivacyPolicy.css";
import ScrollToTopButton from "../components/ScrollToTopButton";

function PrivacyPolicy() {
    return (
        <div className="container my-5">
            <h1 className="text-center mb-5">Polityka Prywatności - Restauracja Sami Swoi</h1>
            <section className="mb-5">
                <h3>Wstęp</h3>
                <p>
                    Niniejsza polityka prywatności opisuje zasady przetwarzania danych osobowych
                    użytkowników korzystających z formularza kontaktowego dostępnego na naszej stronie internetowej.
                    Dokładamy wszelkich starań, aby chronić prywatność osób odwiedzających naszą stronę i korzystających z naszych usług.
                </p>
            </section>

            <section className="mb-5">
                <h3>1. Administrator Danych Osobowych</h3>
                <p>
                    Administratorem danych osobowych jest Restauracja <b>Sami Swoi</b> z siedzibą w Andrychowie 34-120,
                    ul. Włókniarzy 1A, NIP: 551-167-84-73.
                </p>
            </section>

            <section className="mb-5">
                <h3>2. Zakres Przetwarzanych Danych</h3>
                <p>Za pośrednictwem formularza kontaktowego przetwarzamy następujące dane osobowe:</p>
                <ul>
                    <li>Imię i nazwisko</li>
                    <li>Adres e-mail</li>
                    <li>Numer telefonu (opcjonalnie)</li>
                    <li>Temat wiadomości</li>
                    <li>Treść wiadomości</li>
                </ul>
            </section>

            <section className="mb-5">
                <h3>3. Cel Przetwarzania Danych</h3>
                <p>
                    Dane osobowe przetwarzane są wyłącznie w celu:
                </p>
                <ul>
                    <li>Odpowiedzi na przesłane przez użytkownika zapytania,</li>
                    <li>Udzielenia informacji na temat naszych usług lub oferty.</li>
                </ul>
                <p>
                    Dane nie będą wykorzystywane w żadnym innym celu.
                </p>
            </section>

            <section className="mb-5">
                <h3>4. Podstawa Prawna Przetwarzania Danych</h3>
                <p>
                    Przetwarzanie danych osobowych odbywa się na podstawie zgody użytkownika (art. 6 ust. 1 lit. a RODO).
                </p>
            </section>

            <section className="mb-5">
                <h3>5. Okres Przechowywania Danych</h3>
                <p>
                    Dane osobowe będą przechowywane przez okres niezbędny do udzielenia odpowiedzi na zapytanie lub do momentu
                    wycofania zgody przez użytkownika.
                </p>
            </section>

            <section className="mb-5">
                <h3>6. Prawa Użytkownika</h3>
                <p>
                    Zgodnie z przepisami RODO, przysługują Ci następujące prawa:
                </p>
                <ul>
                    <li>Prawo dostępu do swoich danych osobowych,</li>
                    <li>Prawo do ich sprostowania,</li>
                    <li>Prawo do usunięcia danych,</li>
                    <li>Prawo do ograniczenia przetwarzania,</li>
                    <li>Prawo do przenoszenia danych,</li>
                    <li>Prawo do wycofania zgody w dowolnym momencie.</li>
                </ul>
                <p>
                    W celu realizacji swoich praw możesz skontaktować się z nami poprzez adres e-mail:
                    <a href="mailto:bracia1@onet.pl"> bracia1@onet.pl</a>.
                </p>
            </section>

            <section className="mb-5">
                <h3>7. Odbiorcy Danych</h3>
                <p>Twoje dane osobowe nie są przekazywane żadnym podmiotom zewnętrznym, chyba że będzie to wymagane przepisami prawa.</p>
            </section>

            <section className="mb-5">
                <h3>8. Bezpieczeństwo Danych</h3>
                <p>
                    Dokładamy wszelkich starań, aby zapewnić bezpieczeństwo Twoich danych osobowych.
                </p>
            </section>

            <section className="mb-5">
                <h3>9. Zmiany Polityki Prywatności</h3>
                <p>
                    Zastrzegamy sobie prawo do wprowadzenia zmian w niniejszej polityce prywatności. Wszelkie zmiany będą publikowane na naszej stronie.
                </p>
            </section>

            <section className="mb-5">
                <h3>10. Kontakt</h3>
                <p>
                    W przypadku pytań dotyczących przetwarzania Twoich danych, skontaktuj się z nami:
                </p>
                <ul>
                        <li>E-mail: <a href="mailto:bracia1@onet.pl">bracia1@onet.pl</a></li>
                        <li>Telefon: +48 795 596 427</li>
                </ul>
            </section>

            <footer className="text-center my-5">
                <p>Data ostatniej aktualizacji: 17 listopada 2024</p>
            </footer>
        </div>
    );
}

export default PrivacyPolicy;